<template>
  <ContextMenuTrigger as-child>
    <slot></slot>
  </ContextMenuTrigger>
</template>

<script setup lang="ts">
import { ContextMenuTrigger } from "reka-ui";
</script>
